import { IStreamChannelList, IStreamChannelListData } from '../../interface/streamChannelList';
import { useProfileStore } from '../../store/useProfileStore';
import paths, { getKisaanBaseURL } from '../paths';
import { StreamClient } from '../streams/axiosStreamClient';
import { KisaanClient } from './axiosKisaanClient';
import { IExchangeTokenData, IExchangeTokenResponse } from './interface';

export const syncStreamChannels = async () => {
  const hasDefaultFeedChannel = useProfileStore.getState()?.hasUserFeedVideoChannel();
  if (!useProfileStore.getState().streamConfig?.access_token) {
    return;
  }

  try {
    if (!hasDefaultFeedChannel) {
      const headers = {
        'x-stream-token': `Bearer ${useProfileStore.getState().streamConfig?.access_token}`,
      };
      const uri = `${getKisaanBaseURL()}/kisaan/user/videoChannelSync/${useProfileStore.getState().userProfile?.user.id}`;
      const channels = await KisaanClient.post<IStreamChannelListData>(uri, null, {
        headers: headers,
      });
      if (channels.data) {
        // console.log('Video channel data => ', channels.data?.data);
        useProfileStore.getState().setVideoChannels(channels.data?.data?.data);
      }
    }
  } catch (error) {
    console.error(error);
  }
};

export const exchangeTokenAsync = async (
  userId: string,
  params: string[] = [],
  setModerationFeedConfig?: Function,
  setModerationStreamConfig?: Function
): Promise<IExchangeTokenData | undefined> => {
  const exchangeTokenPath = paths.getExchangeTokenUrl(userId);
  try {
    const exchangeTokenData = await KisaanClient.get<IExchangeTokenResponse>(exchangeTokenPath, {
      params: {
        sync: params,
      },
      paramsSerializer: {
        indexes: true, // use brackets with indexes
      },
    });
    const { mastodonToken, peerTube, qnaUser } = exchangeTokenData?.data?.data;
    if (mastodonToken) {
      useProfileStore?.getState().setFeedConfig(mastodonToken);
      setModerationFeedConfig?.(mastodonToken);
    }

    if (peerTube) {
      useProfileStore?.getState().setStreamConfig(peerTube);
      setModerationStreamConfig?.(peerTube);
    }

    //qna not required as qna token is same as ninjacart accesstoken
    return exchangeTokenData?.data?.data;
  } catch (error) {
    console.error('Exchange token api err : ', error);
  }

  return undefined;
};

export const updateUserLanguage = async (languageCode: string) => {
  try {
    if (useProfileStore?.getState()?.userProfile?.user) {
      const payload = { languageCode };
      const userId = useProfileStore?.getState()?.userProfile?.user?.id;
      const realmId = useProfileStore?.getState()?.userProfile?.realm?.id;

      if (!userId || !realmId) {
        console.log('No user or realm present! Aborting user language preference sync');
        return;
      }

      const updateUserLangWithPatch = await KisaanClient.patch(
        paths.editProfileSubmit(userId, realmId),
        payload
      );

      if (updateUserLangWithPatch?.data?.data) {
        const userDetail: any = {
          realm: updateUserLangWithPatch?.data?.data?.realmData?.Realm,
          user: updateUserLangWithPatch?.data?.data?.userData?.User,
          access_token: useProfileStore?.getState()?.userProfile?.access_token,
        };

        useProfileStore?.getState()?.setUserProfile(userDetail);
      }

      return updateUserLangWithPatch?.data ?? undefined;
    }
  } catch (error) {
    console.error('Update failed for language code!!!', error);
  }

  return undefined;
};

export const getFeedExchangeTokenSync = async (userId: string) => {
  const exchangeTokenPath = paths.getExchangeTokenUrl(userId);
  try {
    const exchangeTokenData = await KisaanClient.get<IExchangeTokenResponse>(exchangeTokenPath, {
      params: {
        sync: ['Feed'],
      },
      paramsSerializer: {
        indexes: true, // use brackets with indexes
      },
    });

    const { mastodonToken } = exchangeTokenData?.data?.data;
    return mastodonToken;
  } catch (err) {
    console.error('Error getting acces token. ', err);
  }
};
